import React from "react";

import { Typeahead } from "../../../../form-inputs/typeahead";
import NotificationBar from "../../../../notification-bar";

const AllergyInfo = (props) => {
    const contains = props.data && props.data.contains ? props.data.contains : [];
    const mayContain = props.data && props.data.mayContain ? props.data.mayContain : [];
    const doesNotContain = props.data && props.data.doesNotContain ? props.data.doesNotContain : [];

    const setAllergyInfo = (name, values) => {
        const allergyInfo = {
            contains: [...contains],
            mayContain: [...mayContain],
            doesNotContain: [...doesNotContain],
        };
        allergyInfo[name] = values;

        props.updateField("allergens", allergyInfo);
        document.getElementsByName(name)[0].focus();
    };

    return (
        <div>
            <h3>Allergy Information</h3>
            <NotificationBar type="warning" message="Please use root attributes for Allergy Information moving forward" />
            <Typeahead
                name="contains"
                label="Contains"
                options={props.allergenOptions}
                defaultValue={contains}
                updateOnChange={setAllergyInfo}
                multiple={true}
                disabled={true}
            />

            <Typeahead
                name="mayContain"
                label="May Contain"
                options={props.allergenOptions}
                defaultValue={mayContain}
                updateOnChange={setAllergyInfo}
                multiple={true}
                disabled={true}
            />

            <Typeahead
                name="doesNotContain"
                label="Does Not Contain"
                options={props.allergenOptions}
                defaultValue={doesNotContain}
                updateOnChange={setAllergyInfo}
                multiple={true}
                disabled={true}
            />
        </div>
    );
};

export default AllergyInfo;
